import React, { useState, useEffect } from "react";
import { Spin, Layout, Tag } from "antd";
import History from "../components/Steps/History";
import PaymentResult from "../components/Steps/PaymentResult";
import ElectricityWaterBill from "../components/Steps/ElectricityWaterBill";
import { useLocation, useHistory } from "react-router-dom";
const { Header, Content } = Layout;

const tagsData = ["electricity", "water", "history"];

const Home = ({ token }) => {
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState("electricity"); //electricity , water, history , payment-result
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    hanleProcessPaymentReturn();
  }, [location, history]);

  const hanleProcessPaymentReturn = async () => {
    const queryParams = new URLSearchParams(location.search);
    const amount = queryParams.get("amount");
    const payment_type = queryParams.get("payment_type");
    const reference_number = queryParams.get("reference_number");
    const status = queryParams.get("status");
    const trans_ref_no = queryParams.get("trans_ref_no");
    const website_id = queryParams.get("website_id");
    const signature = queryParams.get("signature");

    if (
      amount &&
      payment_type &&
      reference_number &&
      status &&
      trans_ref_no &&
      website_id &&
      signature
    ) {
      setStep("payment-result");
    } else if (!step && token) {
      setStep("electricity");
    }
  };

  return (
    <Spin tip="Tải dữ liệu" size="large" spinning={loading}>
      <Layout className="w-full">
        <Header className="bg-primary w-full">
          <div className="text-center w-full">
            <span className="text-lg font-semibold  whitespace-nowrap text-white">
              Thanh Toán Tiền Điện
            </span>
          </div>
        </Header>
        <Content>
          <div className="w-full max-w-[100%] overflow-x-auto whitespace-nowrap scrollbar-hide bg-primary py-3 justify-center flex">
            {tagsData.map((tag) => (
              <Tag.CheckableTag
                key={tag}
                checked={step === tag}
                onChange={() => setStep(tag)}
                className="menu-utilities"
              >
                <div className="flex items-center gap-0">
                  {tag === "electricity" && (
                    <>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="mr-2"
                      >
                        <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z" />
                        <path d="m13 12-2 5h4l-2 5" />
                      </svg>
                      <div className="text-[14px] font-semibold">Tiền Điện</div>
                    </>
                  )}
                  {tag === "water" && (
                    <>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="mr-2"
                      >
                        <path d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z" />
                      </svg>
                      <div className="text-[14px] font-semibold">Tiền Nước</div>
                    </>
                  )}

                  {tag === "history" && (
                    <>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="mr-2"
                      >
                        <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
                        <path d="M3 3v5h5" />
                      </svg>
                      <div className="text-[14px] font-semibold">Lịch sử</div>
                    </>
                  )}
                </div>
              </Tag.CheckableTag>
            ))}
          </div>
        </Content>
      </Layout>

      <div className="bg-white min-h-screen">
        {(step !== "history" && step !== "payment-result") && (
          <div
            className="w-full h-[300px] absolute"
            style={{
              backgroundImage: `url(/images/bg-img.jpg)`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center center",
            }}
          ></div>
        )}
        {(step === "electricity" || step === "water") && (
          <ElectricityWaterBill
            setStep={setStep}
            setLoading={setLoading}
            loading={loading}
            step={step}
            token={token}
          />
        )}
        {step === "history" && (
          <History
            setStep={setStep}
            setLoading={setLoading}
            loading={loading}
          />
        )}
        {step === "payment-result" && (
          <PaymentResult setLoading={setLoading} loading={loading}  onChangeStep={setStep}/>
        )}
      </div>
    </Spin>
  );
};

export default Home;
